import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from '../auth.service';

@Injectable()
export class TokenRefreshIntereptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}
  private refreshSubject: Subject<any> = new Subject<any>();
  private refreshToken() {
    this.refreshSubject.subscribe({
      complete: () => {
        this.refreshSubject = new Subject<any>();
      },
    });
    if (this.refreshSubject.observers.length === 1) {
      this.authService.refreshAccessToken().subscribe(this.refreshSubject);
    }
    return this.refreshSubject;
  }

  updateHeader(req: HttpRequest<any>) {
    const authToken = localStorage.getItem('token');
    req = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${authToken}`),
    });
    return req;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.endsWith('logout')) {
      return next.handle(req);
    } else if (req.url.endsWith('token/refresh')) {
      // if refresh token is expired
      return next.handle(req).pipe(
        catchError((error) => {
          if (this.unauthorizedResponse(error)) {
            if (this.authService.hasCurrentRefreshToken()) {
              this.authService.logout().toPromise();
              location.reload();
            }
          }
          return throwError(error);
        })
      );
    } else {
      // refresh access token if resource is requested with an expired token
      return next.handle(req).pipe(
        catchError((error, caught) => {
          if (error instanceof HttpErrorResponse) {
            if (this.unauthorizedResponse(error)) {
              return this.refreshToken().pipe(
                switchMap(() => {
                  return next.handle(this.updateHeader(req));
                })
              );
            } else {
              return throwError(error);
            }
          }
          return caught;
        })
      );
    }
  }

  unauthorizedResponse(error: HttpErrorResponse): boolean {
    return !!error.status && error.status === 401;
  }
}
